/* ============================================
   VidaFIT — Precio secundario en VES
   ============================================
   Requiere window.VidafitConfig.vesRateApiUrl
   configurado en theme.liquid.

   El API debe retornar JSON con la tasa de cambio.
   Formato esperado: { "rate": 36.5 }
   ============================================ */

(function () {
  var CACHE_KEY = 'vidafit_ves_rate_cache';
  var CACHE_TTL = 4 * 60 * 60 * 1000; // 4 horas en ms

  // ── Helpers de formato ──────────────────────────────────────────────────

  function formatVES(amount) {
    // Formato: Bs. 1.234,56
    var parts = amount.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'Bs. ' + parts[0] + ',' + parts[1];
  }

  // ── Tasa de cambio (con caché en sessionStorage) ─────────────────────────

  function getRate() {
    return new Promise(function (resolve, reject) {
      // Intentar desde caché
      try {
        var cached = sessionStorage.getItem(CACHE_KEY);
        if (cached) {
          var parsed = JSON.parse(cached);
          if (Date.now() - parsed.timestamp < CACHE_TTL && parsed.rate) {
            return resolve(parsed.rate);
          }
        }
      } catch (e) {
        // sessionStorage no disponible o datos corruptos — continuar
      }

      var apiUrl = window.VidafitConfig && window.VidafitConfig.vesRateApiUrl;

      // Sin URL configurada → usar tasa mock hasta que el API esté listo
      if (!apiUrl) {
        console.info('[VidafitCurrency] Usando tasa mock: 475. Configura VES Rate API URL en el Theme Editor.');
        return resolve(475);
      }

      fetch(apiUrl)
        .then(function (res) {
          if (!res.ok) throw new Error('API respondió con status ' + res.status);
          return res.json();
        })
        .then(function (data) {
          // Formato esperado: { tasas: [{ moneda: "USD", tasa: "475.00830000", ... }] }
          var entry = data.tasas && data.tasas.find(function (t) { return t.moneda === 'USD'; });
          var rate = entry ? parseFloat(entry.tasa) : NaN;
          if (!rate || isNaN(rate)) {
            throw new Error('No se encontró tasa USD en el response: ' + JSON.stringify(data));
          }
          try {
            sessionStorage.setItem(CACHE_KEY, JSON.stringify({ rate: rate, timestamp: Date.now() }));
          } catch (e) {
            // sessionStorage lleno — continuar sin caché
          }
          resolve(rate);
        })
        .catch(reject);
    });
  }

  // ── Render del precio secundario en VES ─────────────────────────────────

  function renderSecondaryPrices(rate) {
    var secondaryEls = document.querySelectorAll('[data-secondary-price]');

    secondaryEls.forEach(function (secondaryEl) {
      // El elemento con data-price-usd es el hermano anterior
      var priceEl = secondaryEl.previousElementSibling;
      if (!priceEl || !priceEl.hasAttribute('data-price-usd')) {
        // Buscar hacia arriba dentro del wrapper por si hay elementos intermedios
        var parent = secondaryEl.parentElement;
        if (parent) {
          priceEl = parent.querySelector('[data-price-usd]');
        }
      }
      if (!priceEl) return;

      var cents = parseInt(priceEl.getAttribute('data-price-usd'), 10);
      if (isNaN(cents) || cents === 0) {
        secondaryEl.textContent = '';
        return;
      }

      var usd = cents / 100;
      var label = secondaryEl.getAttribute('data-secondary-price-label');
      secondaryEl.textContent = (label ? label + ': ' : '') + formatVES(usd * rate);
    });
  }

  // ── Refresh público ──────────────────────────────────────────────────────

  function refreshPrices() {
    getRate()
      .then(function (rate) {
        renderSecondaryPrices(rate);
      })
      .catch(function (err) {
        console.warn('[VidafitCurrency]', err.message);
        // Limpiar precios secundarios para no mostrar datos desactualizados
        document.querySelectorAll('[data-secondary-price]').forEach(function (el) {
          el.textContent = '';
        });
      });
  }

  // ── Guardar tasa BCV como cart attribute antes del checkout ─────────────────

  function saveRateAndCheckout() {
    getRate()
      .then(function (rate) {
        var today = new Date().toLocaleDateString('es-VE', {
          day: '2-digit', month: '2-digit', year: 'numeric'
        });
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              'ves_rate': rate.toFixed(8),
              'ves_rate_date': today
            }
          })
        });
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function () {
        // Si algo falla, redirigir igual (no bloquear al cliente)
        window.location.href = '/checkout';
      });
  }

  function initCheckoutInterceptor() {
    document.addEventListener('DOMContentLoaded', function () {
      var btn = document.getElementById('vidafit-checkout-btn');
      if (!btn) return;

      btn.addEventListener('click', function () {
        btn.disabled = true;
        btn.textContent = 'Redirigiendo...';
        saveRateAndCheckout();
      });
    });
  }

  // ── Init ─────────────────────────────────────────────────────────────────

  function init() {
    document.addEventListener('DOMContentLoaded', function () {
      refreshPrices();
    });

    // Restauración desde bfcache (browser back/forward)
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        refreshPrices();
      }
    });

    initCheckoutInterceptor();
  }

  // Exponer API pública para uso desde el script inline de variantes
  window.VidafitCurrency = { refreshPrices: refreshPrices };

  init();
})();
